import Ax from 'axios';
import store from '../utils/store';
import moment from 'moment';
import i18n from '../translations/i18n';
import { getToken } from '../screen/auth/action';
import {
  Campaign,
  LocalActivity,
  Redeem,
  Storefront,
} from '@mui/icons-material';
// Log Rocket Setting

// Ax.interceptors.request.use(function (config) {
//   const langCode = localStorage.getItem('language');
//   config.headers.lang = langCode;
//   return config;
// });
// Ax.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error && error.response && error.response.status == '401') {
//       try {
//         localStorage.clear();
//         store.store.dispatch({ type: 'LOGOUT' });
//         window.location.href = '/';
//       } catch (e) {}
//     }

//     return Promise.reject(error);
//   },
// );

// const apiUrl = "http://api.humbee.hftsolution-dev.xyz";
const apiUrl = process.env.REACT_APP_API_URL;

export const axios = Ax;

export default apiUrl;

export const unitCaseEnum = {
  CASE: 1,
  UNIT: 2,
};

export const UserTypeArr = (index) => {
  const arr = [
    { name: i18n.t('userType.MASON'), id: 1 },
    { name: i18n.t('userType.DISTRIBUTOR'), id: 2 },
    { name: i18n.t('userType.RETAILER'), id: 3 },
    { name: i18n.t('userType.CEMENT_COMPANY'), id: 4 },
    { name: i18n.t('userType.HUMBEE_SUPPORT'), id: 5 },
    { name: i18n.t('userType.DEALER_RETAILER'), id: 6 },
    { name: i18n.t('userType.PROJECT'), id: 7 },
    { name: i18n.t('userType.ASSOCIATE'), id: 8 },
  ];

  return arr[index];
};

export const currencyNumber = (amt) => {
  return amt.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const bookStatusFunction = (index) => {
  const arr = [
    { name: 'DISPATCH PLAN PENDING', id: 1, color: '#F49D3F' },
    { name: 'COMPLETED', id: 2, color: 'rgb(52, 199, 89)' },
    { name: 'PARTIAL DISPATCH PLAN', id: 3, color: '#2E27AF' },
    { name: 'APPROVED', id: 4, color: '#7F00BB' },
    { name: 'REJECTED', id: 5, color: '#FF0800' },
  ];
  return arr[index];
};

export const bookStatus = {
  DISPATCH_PLAN_PENDING: 1,
  COMPLETED: 2,
  PARTIAL_DISPATCH_PLAN: 3,
  APPROVED: 4,
  REJECTED: 5,
};

export const bookingApprovalStatus = (index) => {
  const arr = [
    { name: 'PENDING', id: 1, color: '#F49D3F' },
    { name: 'APPROVED', id: 2, color: 'rgb(52, 199, 89)' },
    { name: 'CANCELLED', id: 3, color: '#FF0800' },
  ];
  return arr[index];
};
export const orderApprovalStatusMap = (index) => {
  const arr = [
    {
      name: 'PENDING',
      id: 1,
      fontColor: '#F49D3F',
    },
    {
      name: 'APPROVED',
      id: 2,
      fontColor: '#01522B',
    },
    {
      name: 'CANCELLED',
      id: 3,
      fontColor: '#F9485A',
    },
  ];
  return arr[index];
};

export const paymentStatusObject = {
  INITIATED: 1,
  PAID_WITH_CREDIT: 2,
  PAID_WITH_CASH: 3,
  CASH_PAYMENT_FAILED: 4,
  CREDIT_APPROVED: 5,
  CREDIT_REJECTED: 6,
  DIRECT_PAYMENT_TO_COMPANY: 7,
};

export const primaryIndustry = {
  BCM: 1,
  FMCG: 2,
};

export const newSecondaryIndustryTypeArr = {
  PAINT_AND_HARDWARE: 1,
  TMT: 2,
  ANGLES: 3,
  ERW: 4,
  CEMENT: 5,
  FOOD: 6,
  PERSONAL_HYGIENE: 7,
};

export const getRGBAColor = (color) => {
  let r, g, b;

  if (color.startsWith('#')) {
    // Handle hex color
    const hex = color.replace('#', '');
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else {
    // Handle named colors (basic implementation for common colors)
    const namedColors = {
      red: { r: 255, g: 0, b: 0 },
      green: { r: 0, g: 255, b: 0 },
      blue: { r: 0, g: 0, b: 255 },
      // Add more named colors if needed
    };
    ({ r, g, b } = namedColors[color] || { r: 0, g: 0, b: 0 }); // Default to black if color not found
  }

  return `rgba(${r}, ${g}, ${b}, 0.2)`;
};
// Secondary Approval Status
export const secondaryOrderApproval = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};
export const secondaryOrderApprovalArr = [
  { name: 'PENDING', color: '#F49D3F' },
  { name: 'APPROVED', color: 'rgb(52, 199, 89)' },
  { name: 'REJECTED', color: '#FF0800' },
  { name: 'CANCELLED', color: '#FF0800' },
];

export const secondaryOrderStatus = {
  CREATED: 1,
  DELIVERED: 2,
  REJECTED: 3,
  DISPATCH_PLAN_CREATED: 4,
  PARTIALLY_DELIVERED: 5,
};
export const secondaryOrderStatusArr = [
  { name: 'CREATED', color: '#F99D1C' },
  { name: 'DELIVERED', color: 'rgb(52, 199, 89)' },
  { name: 'CANCELLED', color: '#FF0800' },
  { name: 'DISPATCH PLAN CREATED', color: '#7F00BB' },
  { name: 'PARTIALLY DELIVERED', color: '#ffa500' },
];

export const orderStatusArrMap = (index) => {
  const status = [
    { name: 'CREATED', color: '#F99D1C', id: 1 },
    { name: 'DISPATCHED', color: '#ffa500', id: 2 },
    { name: 'DELIVERED', color: '#01522B', id: 3 },
    { name: 'CANCELLED', color: '#F9485A', id: 4 },
    { name: 'PARTIALLY DISPATCHED', color: '#7F00BB', id: 5 },
    { name: 'PARTIALLY DELIVERED', color: '#ffa500', id: 6 },
  ];
  return status[index];
};
// Image Links
export const imageLinksForGujWhichWillBeFiltered = [
  'https://api-prod.humbee.click/banner_images/get-slider-image-by-id/33',
];
export const imageLinksForNonGujWhichWillBeFiltered = [
  'https://api-prod.humbee.click/banner_images/get-slider-image-by-id/34',
  'https://api-prod.humbee.click/banner_images/get-slider-image-by-id/35',
  'https://api-prod.humbee.click/banner_images/get-slider-image-by-id/36',
];

export const bookingApprovalStatusEnum = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const insuranceEnums = {
  LIFE_INSURANCE: 1,
  MEDICAL_INSURANCE: 2,
};

export const OrderBookingApprovalStatusOfCompanyAdmin = {
  PENDING: 1,
  APPROVED: 2,
  CANCELLED: 3,
};

export const OrderApprovalStatusOfCompanyAdmin = {
  PENDING: 1,
  APPROVED: 2,
  CANCELLED: 3,
};

export const adminApprovalStatusArr = [
  { name: 'PENDING', color: '#F49D3F' },
  { name: 'APPROVED', color: 'rgb(52, 199, 89)' },
  { name: 'CANCELLED', color: '#FF0800' },
];

export const LedgerPaymentTypes = {
  LEDGER_PAYMENT: 1,
  PARTIAL_LEDGER_PAYMENT: 2,
  TOP_UP: 3,
};

export const companyIndustryType = {
  CEMENT: 1,
  STEEL: 2,
  ERW: 3,
  ANGLE: 4,
  FMCG: 5,
  PAINTS: 6,
};

export let GujaratCo = [];
export const CentralGujaratDistrictIDForBenefit = [200, 201, 208];

if (process.env.REACT_APP_PROD === 'true') {
  GujaratCo = [
    {
      name: 'Welspun Shield TMT',
      id: 288311,
      industry_type: companyIndustryType['STEEL'],
    },
    {
      name: 'Welspun Corp',
      id: 291338,
      industry_type: companyIndustryType['ERW'],
    },
    {
      name: 'GRAVITY FERROUS ERW',
      id: 293612,
      industry_type: companyIndustryType['ERW'],
    },
    {
      name: 'BHAWANI MOULDERS',
      id: 293613,
      industry_type: companyIndustryType['ANGLE'],
    },
  ]; //Prod
} else {
  GujaratCo = [
    {
      name: 'Welspun Shield TMT',
      id: 288311,
      industry_type: companyIndustryType['STEEL'],
    },
    {
      name: 'Welspun Corp',
      id: 291338,
      industry_type: companyIndustryType['ERW'],
    },
    {
      name: 'GRAVITY FERROUS ERW',
      id: 293612,
      industry_type: companyIndustryType['ERW'],
    },
    {
      name: 'BHAWANI MOULDERS',
      id: 293613,
      industry_type: companyIndustryType['ANGLE'],
    },
  ]; //Dev
}

export let CompanyFactoryPrice = [];
// Welspun ID && TMT AMBA & Bhawani Moulders & Gravity Ferrous
if (process.env.REACT_APP_PROD === 'true') {
  CompanyFactoryPrice = [288311, 287091, 293612, 293613]; //Prod
} else {
  CompanyFactoryPrice = [288311, 287091, 293612, 293613]; //Dev
}

export let companiesFORPRICE = [];
if (process.env.REACT_APP_PROD === 'true') {
  companiesFORPRICE = [288311, 287091]; //Prod
} else {
  companiesFORPRICE = [288311, 287091]; //Dev
}

export const stateID = [10, 11, 12];

export const includesGujaratStateAndOther = (loginUser) => {
  return stateID.includes(loginUser?.company_details?.district_id?.state?.id);
};

export const deliveryType = {
  UP: 1,
  MIDDLE: 2,
  DOWN: 3,
};

export const deliveryTypeDropDown = [
  { label: 'UP', value: deliveryType.UP },
  { label: 'MIDDLE', value: deliveryType.MIDDLE },
  { label: 'DOWN', value: deliveryType.DOWN },
];

export const UserTypeDict = {
  MASON: 1,
  DISTRIBUTOR: 2,
  RETAILER: 3,
  CEMENT_COMPANY: 4,
  HUMBEE_SUPPORT: 5,
  DEALER_RETAILER: 6,
  PROJECT: 7,
  ASSOCIATE: 8,
};

export const monthsInYear = {
  JANUARY: 1,
  FEBRUARY: 2,
  MARCH: 3,
  APRIL: 4,
  MAY: 5,
  JUNE: 6,
  JULY: 7,
  AUGUST: 8,
  SEPTEMBER: 9,
  OCTOBER: 10,
  NOVEMBER: 11,
  DECEMBER: 12,
};

export const monthsInYearDropDown = [
  { label: 'JANUARY', value: monthsInYear['JANUARY'] },
  { label: 'FEBRUARY', value: monthsInYear['FEBRUARY'] },
  { label: 'MARCH', value: monthsInYear['MARCH'] },
  { label: 'APRIL', value: monthsInYear['APRIL'] },
  { label: 'MAY', value: monthsInYear['MAY'] },
  { label: 'JUNE', value: monthsInYear['JUNE'] },
  { label: 'JULY', value: monthsInYear['JULY'] },
  { label: 'AUGUST', value: monthsInYear['AUGUST'] },
  { label: 'SEPTEMBER', value: monthsInYear['SEPTEMBER'] },
  { label: 'OCTOBER', value: monthsInYear['OCTOBER'] },
  { label: 'NOVEMBER', value: monthsInYear['NOVEMBER'] },
  { label: 'DECEMBER', value: monthsInYear['DECEMBER'] },
];

export const customerType = {
  DEALER: UserTypeDict['RETAILER'],
  PROJECT: UserTypeDict['PROJECT'],
  ASSOCIATE: UserTypeDict['ASSOCIATE'],
  SELF: 'SELF',
};

export const LedgerTransactionPaymentEnum = [
  { name: 'PENDING', color: '#F49D3F' },
  { name: 'FAILED', color: '#FF0800' },
  { name: 'COMPLETED', color: 'green' },
];

export const customerTypeDropDown = () => {
  return [
    { label: i18n.t('userType.RETAILER'), value: customerType['DEALER'] },
    { label: 'PROJECT', value: customerType['PROJECT'] },
    { label: 'ASSOCIATE', value: customerType['ASSOCIATE'] },
    { label: 'SELF', value: customerType['SELF'] },
  ];
};
export const customerTypeDropDownFMCG = () => {
  return [{ label: 'SELF', value: customerType['SELF'] }];
};

export function UserTypeSubCategory() {
  return [
    { label: i18n.t('userType.BARBENDER'), value: 1 },
    { label: i18n.t('userType.ENGINEER'), value: 2 },
    { label: i18n.t('userType.BAR_BENDER'), value: 3 },
    { label: i18n.t('userType.ARCHITECH'), value: 4 },
    { label: i18n.t('userType.FABRICATOR'), value: 5 },
    { label: i18n.t('userType.PAINTER'), value: 6 },
  ];
}

export const secondaryPermission = {
  ORDER_ADMIN: 'ORDER_ADMIN',
  PAYMENT_ADMIN: 'PAYMENT_ADMIN',
  GIFT_ADMIN: 'GIFT_ADMIN',
  INVOICE_ADMIN: 'INVOICE_ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
};

export const bookingApprovalStatusEnums = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  COMPLETED: 4,
};

export const InvoiceState = (index) => {
  const arr = [
    { name: 'REJECTED', invoiceState: 'REJECTED', id: 1, color: '#FF0800' },
    {
      name: 'VERIFIED',
      invoiceState: 'DELIVERED',
      id: 2,
      color: 'rgb(52, 199, 89)',
    },
    { name: 'UNVERIFIED', invoiceState: 'PENDING', id: 3, color: '#F49D3F' },
  ];
  return arr[index];
};

export const secondaryPermissionDropDown = [
  { label: 'ORDER ADMIN', value: secondaryPermission['ORDER_ADMIN'] },
  { label: 'PAYMENT ADMIN', value: secondaryPermission['PAYMENT_ADMIN'] },
  // { label: 'GIFT ADMIN', value: secondaryPermission['GIFT_ADMIN'] },
  // { label: 'INVOICE ADMIN', value: secondaryPermission['INVOICE_ADMIN'] },
  // { label: 'COMPANY ADMIN', value: secondaryPermission['COMPANY_ADMIN'] },
  // {label: "PRICE ADMIN", value: secondaryPermission['PRICE_ADMIN']}
];

export const UnitType = {
  Bags: 1,
  MetricTon: 2,
};

export const UserFileDict = {
  AADHAR_CARD: 1,
  PAN_CARD: 2,
  DRIVING_LICENCE: 3,
  VOTER_ID: 4,
  RATION_CARD: 5,
  BANK_PASSBOOK: 6,
  PASSPORT: 7,
  USER_PHOTO: 8,
  GSTIN: 9,
};

export const idsMap = {
  PAN_CARD: 2,
  GST_NUMBER: 9,
};

export const IdsArrayDropDown = [
  { label: 'PAN CARD', value: 2 },
  { label: 'GST NUMBER', value: 9 },
];

export const RelationshipDictForForm = {
  MOTHER: 1,
  FATHER: 2,
  SISTER: 3,
  BROTHER: 4,
  CHILD: 5,
  SPOUSE: 6,
};

export const transactionType = {
  BUY: 1,
  SELL: 2,
};

export const LedgerTransactionType = {
  DEBIT: 1,
  CREDIT: 2,
  DEBIT_SPLIT: 3,
  CREDIT_SPLIT: 4,
};

export const OperationType = {
  ADD: 1,
  UPDATE: 2,
  DELETE: 3,
};

export const searchByTypes = {
  PHONE: 1,
  NAME: 2,
  PAN: 3,
  GST: 4,
};

export function validateIsPAN(value) {
  const pattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  return pattern.test(value);
}

export function validateIsGSTIN(value) {
  const pattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9A-Z]{1}$/;
  return pattern.test(value);
}

export const RelationshipObjForForm = [
  { name: 'SPOUSE', id: 6 },
  { name: 'CHILD', id: 5 },
];
export const productTypes = [
  { name: 'STEEL', id: 10 },
  { name: 'PAINTS', id: 11 },
  { name: 'PIPES', id: 7 },
  { name: 'ELECTRICAL', id: 6 },
  { name: 'HARDWARE_AND_SANITARY', id: 12 },
  { name: 'TILES', id: 9 },
  { name: 'PLYWOOD', id: 13 },
];

export const FoodObjForForm = [
  { name: 'Veg', id: 1 },
  { name: 'Non-Veg', id: 2 },
  { name: 'Jain Food', id: 3 },
];
export const FoodDictForForm = {
  VEG: 1,
  NONVEG: 2,
};

export const GenderDictForForm = {
  MALE: 1,
  FEMALE: 2,
};
export const QualificationObjForForm = [
  { name: '10th', id: 1 },
  { name: '12th', id: 2 },
  { name: 'Graduation', id: 1 },
  { name: 'MBA', id: 2 },
  { name: 'Others', id: 1 },
];
export const GenderObjForForm = [
  { name: 'MALE', id: 1 },
  { name: 'FEMALE', id: 2 },
];
export const DestinationObjForForm = [
  { name: 'Domestic', id: 1 },
  { name: 'International', id: 2 },
];

export const formType = {
  STRAIGHT: 1,
  BEND: 2,
};
export const Icoterms = {
  EX: 1,
  FOR: 2,
};

export const formtypeDropDown = [
  { label: 'STRAIGHT', value: formType['STRAIGHT'] },
  { label: 'BEND', value: formType['BEND'] },
];

export const IcotermsDropDown = [
  { label: 'EX', value: Icoterms['EX'] },
  { label: 'FOR', value: Icoterms['FOR'] },
];

export const orderStatus = [
  { name: 'PENDING', id: 1, color: '#F49D3F' },
  { name: 'DISPATCHED', id: 2, color: '#7F00BB' },
  { name: 'DELIVERED', id: 3, color: '#7CEA9C' },
  { name: 'REJECTED', id: 4, color: '#FB0E35' },
];

export const orderStatusmap = {
  CREATED: 1,
  DISPATCHED: 2,
  DELIVERED: 3,
  REJECTED: 4,
  PARTIALLY_DISPATCHED: 5,
  PARTIALLY_DELIVERED: 6,
};

export const paymentStatus = [
  { name: 'INITIATED', id: 1, color: '#F49D3F' },
  { name: 'PAID WITH CREDIT', id: 2, color: '#DB9065' },
  { name: 'PAID WITH CASH', id: 3, color: '#6CBEED' },
  { name: 'CASH PAYMENT FAILED', id: 4, color: '#276182' },
  { name: 'CREDIT APPROVED', id: 5, color: '#4785AE' },
  { name: 'CREDIT REJECTED', id: 6, color: '#780216' },
  { name: 'DIRECT PAYMENT TO COMPANY', id: 7, color: '#7389AE' },
];

export const GIFT_STATUS = ['ANNOUNCED', 'GIFTED'];

export const objectToQueryString = (params) =>
  Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');

export const dateFormat = 'YYYY-MM-DD';
export const formatDateString = (rawDate) => {
  return moment(rawDate).format(dateFormat);
};

export function getKeyByValue(object, value) {
  const item = object.find((obj) => obj.value === value);
  return item ? item.label : null;
}

export function getValueByKey(object, key) {
  const item = object.find((obj) => obj.label === key);
  return item ? item.value : null; // return null if label not found
}
export const paymentStatusEnum = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
};
export function isValidNumber(value) {
  return /^\d+(\.\d+)?$/.test(value);
}

export const getUnit = (skuMasterData) => {
  if (skuMasterData) {
    if (skuMasterData.meta_data == null) return 'Ton';
    else return skuMasterData.meta_data.unit;
  } else {
    return 'Ton';
  }
};
export function isValidPhoneNumber(phoneNumber) {
  const phonePattern = /^\d{10}$/;
  return phonePattern.test(phoneNumber);
}

export const getQuantityAndBaseUnits = (id, skuMaster) => {
  // const id = item.prod_id
  const itemDetails = skuMaster[id];
  if (itemDetails?.meta_data?.base_unit) {
    //  let unit_suffix = itemDetails.meta_data.unit;
    //   if(unit_suffix == "units"){
    //     unit_suffix = "Unit"
    //   if(qty > 1) unit_suffix += "s"
    //   }
    return ` ${itemDetails?.meta_data?.base_unit}`;
  } else {
    return ' TON';
  }
};
export const decodeToken = async () => {
  try {
    const token = await getToken();
    if (!token) {
      return null;
    }

    const arrayToken = token.split('.');
    if (arrayToken.length < 2) {
      return null;
    }

    const tokenPayload = JSON.parse(atob(arrayToken[1]));
    return tokenPayload;
  } catch (error) {
    return null;
  }
};

export const employeePermissions = [
  { label: 'Order Admin', value: 'ORDER_ADMIN' },
  { label: 'Payment Admin', value: 'PAYMENT_ADMIN' },
  { label: 'Company Admin', value: 'COMPANY_ADMIN' },
];
export const addEmployeePermissions = [
  { label: 'Order Admin', value: 'ORDER_ADMIN' },
  { label: 'Payment Admin', value: 'PAYMENT_ADMIN' },
];
export const getRoleLabel = (value) => {
  const role = employeePermissions.find((role) => role.value === value);
  return role?.label;
};

export const BeneficiaryType = {
  Beneficiary: 1,
  Nominee: 2,
};
export const SupplierModuleTypeEnum = {
  default: 'default',
  onboarding_enabled: 'onboarding_enabled',
  pricing_enabled: 'pricing_enabled',
  payment_enabled: 'payment_enabled',
  payment_history_enabled: 'payment_history_enabled',
  po_enabled: 'po_enabled',
  po_history_enabled: 'po_history_enabled',
  dp_enabled: 'dp_enabled',
  dp_history_enabled: 'dp_history_enabled',
  inventory_enabled: 'inventory_enabled',
  onward_lifting_enabled: 'onward_lifting_enabled',
  benefits_enabled: 'benefits_enabled',
  flyers_enabled: 'flyers_enabled',
  performance_enabled: 'performance_enabled',
  reports_enabled: 'reports_enabled',
};
export const orderFinalStatusEnum = [
  { name: 'PENDING', id: 'PENDING', color: '#F49D3F' },
  { name: 'APPROVED', id: 'APPROVED', color: '#01522B' },
  { name: 'PARTIALLY DELIVERED', id: 'PARTIALLY_DELIVERED', color: '#6CBEED' },
  { name: 'DELIVERED', id: 'DELIVERED', color: '#7CEA9C' },
  { name: 'CANCELLED', id: 'CANCELLED', color: '#F9485A' },
];
export const orderBookingFinalStatusEnum = [
  { name: 'PENDING', id: 'PENDING', color: '#F49D3F' },
  { name: 'APPROVED', id: 'APPROVED', color: '#01522B' },
  { name: 'PARTIALLY COMPLETED', id: 'PARTIALLY_COMPLETED', color: '#6CBEED' },
  { name: 'COMPLETED', id: 'COMPLETED', color: '#7CEA9C' },
  { name: 'CANCELLED', id: 'CANCELLED', color: '#F9485A' },
];

export const getOrderFinalStatusById = (id) =>
  orderFinalStatusEnum.find((status) => status.id === id);
export const getOrderBookingFinalStatusById = (id) =>
  orderBookingFinalStatusEnum.find((status) => status.id === id);

export const PoliciesList = [
  {
    title: 'Privacy Policy',
    url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Privacy+Policy.pdf',
  },
  {
    title: 'Terms and Conditions',
    url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Terms+of+Use+of+Humbee.pdf',
  },
  {
    title: 'Refund Policy',
    url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Refund+Policy.pdf',
  },
  {
    title: 'Cancellation Policy',
    url: 'https://apppolicieshumbee.s3.ap-south-1.amazonaws.com/Cancelation+Policy.pdf',
  },
];

export const manufacturer_company_type = {
  STEEL: 'STEEL',
  ERW: 'ERW',
  ANGLE: 'ANGLE',
  FMCG: 'FMCG',
  PAINT: 'PAINTS',
};

export const skuKeys = {
  GRADE: 'GRADE',
  LENGTH: 'LENGTH',
  FORM_TYPE: 'FORM_TYPE',

  TYPE: 'TYPE',
  ERW_GRADE: 'ERW_GRADE',
  SUB_GRADE: 'SUB_GRADE',
  NB: 'NB',
  OD: 'OD',
  AREA: 'AREA',
  COATING: 'COATING',
  THICKNESS: 'THICKNESS',
  ERW_LENGTH: 'ERW_LENGTH',
  'NB/OD/AREA': 'NB/OD/AREA',
};

export const IDLength = {
  GST: 15,
  PAN: 10,
};

export const EventTypeEnum = {
  LUCKY_DRAW: { label: 'LUCKY DRAW', value: 1 },
  HUMBEE_UMANG_UTSAV: { label: 'HUMBEE UMANG UTSAV', value: 2 },
  KHUSHIYO_KA_KARVA: { label: 'KHUSHIYO KA KARVA', value: 3 },
  MEGA_LUCKY_DRAW: { label: 'MEGA LUCKY DRAW', value: 4 },
};
export const EventTypeLabels = Object.fromEntries(
  Object.values(EventTypeEnum).map(({ value, label }) => [value, label]),
);
export const GiftTypeEnum = {
  WHITE_GOOD: 1,
  VOUCHER: 2,
};

export const RewardUserTypeEnum = {
  VCP: 1,
  INFLUENCER: 2,
};
export const Base64Image = ({ base64String, altText, style, imageType = 'image/jpeg', onError, onLoad }) => {
  // Detect image type from base64 data if not provided
  const detectImageType = (base64Data) => {
    if (!base64Data) return 'image/jpeg';
    
    // Check for common image type signatures in base64
    if (base64Data.startsWith('/9j/')) return 'image/jpeg';
    if (base64Data.startsWith('iVBORw0K')) return 'image/png';
    if (base64Data.startsWith('R0lGOD')) return 'image/gif';
    if (base64Data.startsWith('UklGR')) return 'image/webp';
    if (base64Data.startsWith('AAAAIGZ0eXA')) return 'image/heic'; // HEIC signature
    
    // Default to JPEG for unknown types (including converted HEIC)
    return 'image/jpeg';
  };

  const finalImageType = imageType === 'image/jpeg' ? detectImageType(base64String) : imageType;
  
  // Handle HEIC files that might not display properly
  const handleImageError = (e) => {
    console.warn('Failed to load image with type:', finalImageType);
    
    // If it's a HEIC file or the detected type fails, try JPEG fallback
    if (finalImageType !== 'image/jpeg') {
      e.target.src = `data:image/jpeg;base64,${base64String}`;
    }
    
    // Call custom error handler if provided
    if (onError) {
      onError(e);
    }
  };

  const handleImageLoad = (e) => {
    if (onLoad) {
      onLoad(e);
    }
  };
  
  if (!base64String) {
    return (
      <div style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        color: '#666',
        border: '1px solid #ddd',
        borderRadius: '4px',
        minHeight: '100px'
      }}>
        No image available
      </div>
    );
  }
  
  return (
    <img
      src={`data:${finalImageType};base64,${base64String}`}
      alt={altText}
      style={style}
      onError={handleImageError}
      onLoad={handleImageLoad}
    />
  );
};

export const StatusEnums = {
  NotVerified: 'Not Verified',
  Verified: 'Verified',
  Approved: 'approved',
  PartiallyCompleted: 'Partially Completed',
  Completed: 'completed',
  Success: 'success',
  Cancelled: 'cancelled',
  Pending: 'pending',
};

const VERIFICATION_STATUS_LABELS = {
  'verified': 'Verified',
  'not_verified': 'Not Verified',
  'pending': 'Pending',
  'under_review': 'Under Review'
};
export const getVerificationStatusLabel = (status) => {
  return VERIFICATION_STATUS_LABELS[status] || status;
};
// Validate phone number
export const validatePhoneNumber = (phoneNumber) => {
  if (phoneNumber && phoneNumber.trim()) {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phoneNumber.trim());
  }
};

export const formatCompleteAddress = (addressDetails) => {
  if (!addressDetails || Object.keys(addressDetails).length === 0) {
    return '';
  }

  const addressParts = [];

  // Add address lines
  if (addressDetails.address_line_1) {
    addressParts.push(addressDetails.address_line_1.trim());
  }

  if (addressDetails.address_line_2) {
    addressParts.push(addressDetails.address_line_2.trim());
  }

  if (addressDetails.address_line_3) {
    addressParts.push(addressDetails.address_line_3.trim());
  }

  // Add landmark if available
  if (addressDetails.landmark) {
    addressParts.push(`Near ${addressDetails.landmark.trim()}`);
  }

  // Add district and state names (directly available in response)
  if (addressDetails.district_name) {
    addressParts.push(addressDetails.district_name.trim());
  }

  if (addressDetails.state_name) {
    addressParts.push(addressDetails.state_name.trim());
  }

  // Add pincode if available (from pincode_id)
  if (addressDetails.pincode_id) {
    addressParts.push(addressDetails.pincode_id.toString());
  }

  return addressParts.filter((part) => part && part.length > 0).join(', ');
};
